// §4.5 partial — admin/trades routes.
// Composer auto-collects this into routes.generated.ts.
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import { AdminLayout } from "../_layout/AdminLayout";

const AdminTradesPage = lazyWithRetry(() => import("./pages/AdminTradesPage"));
const AdminTradeDetailPage = lazyWithRetry(
  () => import("./pages/AdminTradeDetailPage"),
);

// /admin/trades/force-complete is a virtual route handled by the detail page action.
// No dedicated page needed — ForceCompleteButton is embedded in AdminTradeDetailPage.

const routes: RouteObject[] = [
  {
    Component: AdminLayout,
    children: [
      { path: "/admin/trades", Component: AdminTradesPage },
      { path: "/admin/trades/:id", Component: AdminTradeDetailPage },
    ],
  },
];

export default routes;
